import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_edj9u7j4sq: FaireBrandEntity = {
  token: "b_edj9u7j4sq",
  type: "brand",
  name: "KayleeNYC",
  avatarUrl:
    "https://cdn.faire.com/fastly/851228d4038bff5d0a672dbe3f1e16aab1b114dd797375094a22e6fb49c8e326.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3a3a27afdc70a7f79c1ff883574bf934ed93fed755bff8e12ed6198b4904244a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/851228d4038bff5d0a672dbe3f1e16aab1b114dd797375094a22e6fb49c8e326.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3a3a27afdc70a7f79c1ff883574bf934ed93fed755bff8e12ed6198b4904244a.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 1709,
  isTopShop: true,
  isInsider: true,
  description:
    "KayleeNYC is a family owned business and has been wholesaling crystals for over 10 years.  We are dedicated to providing you and your business with quality crystals from Brooklyn, NY.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:44.178Z",
    importedBy: "entity-db-cli",
  },
};
